import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=6f10ccde&scoped=true&"
import script from "./bottom.vue?vue&type=script&lang=js&"
export * from "./bottom.vue?vue&type=script&lang=js&"
import style0 from "./bottom.vue?vue&type=style&index=0&id=6f10ccde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10ccde",
  null
  
)

export default component.exports